<ng-container *transloco="let t">
  @if (isAdmin) {
    <div class="d-flex justify-content-between admin-template">
      @if (filteringEnabled) {
        <!-- Filter part for admin -->
        <div class="d-flex flex-column flex-xxl-row">
          <div class="pe-2">
            <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
          </div>
          <div class="w-180 d-flex">
            <app-select [hasDefault]="true" [items]="genders" [ngModel]="gender" [defaultValue]="undefined"
                        [defaultLabel]="t('app.common.all')" labelKey="id" valueKey="id"
                        labelKeyPrefix="app.common.gender." (ngModelChange)="handleGenderSelection($event)"
                        [fullWidthDropdown]="true"/>
          </div>
          @if ((filterCategories?.length ?? 0) > 0) {
            <div class="w-180 d-flex ps-2">
              <app-select [hasDefault]="true" [items]="filterCategories" [ngModel]="category" [defaultValue]="undefined"
                          [defaultLabel]="t('app.common.all')" [valueKey]="'id'" [labels]="filterCategoriesLabels"
                          (ngModelChange)="handleCategorySelection($event)" [fullWidthDropdown]="true"/>
            </div>
          }
          <div class=" w-180 d-flex ps-2">
            <app-select [items]="raceIds" [labels]="raceNames" [ngModel]="raceId"
                        (ngModelChange)="handleRaceSelection($event)" [fullWidthDropdown]="true"/>
          </div>
          <div class=" w-180 d-flex ps-2">
            <app-select [items]="[MeasurementTypes.GUN_TIME_PRIMARY, MeasurementTypes.CHIP_TIME_PRIMARY]"
                        [labels]="[t('competitor.table.results.gross.time'), t('competitor.table.results.net.time')]"
                        [ngModel]="measurementType" (ngModelChange)="handleMeasurementTypeSelection($event)"
                        [fullWidthDropdown]="true"/>
          </div>
        </div>
      }
      <ng-content select="[slot='resultsTableAdminTrailingWidgets']"></ng-content>
    </div>
  }
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="results-table">
    @if (filteringEnabled && !isAdmin) {
      <!-- Filter part for public-->
      <div class="contestants-filter mb-3">
        <div class="d-flex flex-column justify-content-lg-between flex-lg-row">
          <div class="me-lg-3 pb-2">
            <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                        (searchQuery)="handleSearchInput($event)" [inputValue]="name"/>
          </div>
          <form #f>
            <div class="contestants-filter__grid">
              <div class="contestants-filter__grid-inner">
                <div class="race-dropdown-box">
                  <div ngbDropdown class="dropdown-small" container="body">
                    <div class="dropdown" id="raceDropdown" ngbDropdownToggle>
                      <span class="trim-dropdown-text">
                        <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [srLabel]="race?.nameSr"
                                             [itLabel]="race?.nameIta" [siLabel]="race?.nameSlo"
                                             [bsLabel]="race?.nameBs" [defaultLanguage]="event?.defaultLanguage"
                                             [languages]="languages"/>
                      </span>
                    </div>
                    @if (event?.racesList?.length ?? 0 > 0) {
                      <div ngbDropdownMenu aria-labelledby="raceDropdown">
                        @for (item of event?.racesList;track item) {
                          <button ngbDropdownItem (click)="handleRaceSelection(item.id)">
                            <app-language-output [hrLabel]="item?.name" [enLabel]="item?.nameEng"
                                                 [srLabel]="item?.nameSr" [itLabel]="item?.nameIta"
                                                 [siLabel]="item?.nameSlo" [bsLabel]="item?.nameBs"
                                                 [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
                            @if (item.id === raceId) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>

                <div ngbDropdown class="dropdown-small" container="body">
                  <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                    {{
                      gender
                        ? t("app.common.gender." + gender) : t("competitor.table.gender")
                    }}
                  </div>
                  @if (genders?.length ?? 0 > 0) {
                    <div ngbDropdownMenu aria-labelledby="genderDropdown">
                      <button ngbDropdownItem (click)="handleGenderSelection()">
                        {{t("app.common.all")}}
                        @if ((gender === undefined)) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      @for (item of genders;track item) {
                        <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                          {{t("app.common.gender." + item.id)}}
                          @if (item.id === gender) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                      }
                    </div>
                  }
                </div>
                @if (filterCategories?.length ?? 0 > 0) {
                  <div ngbDropdown class="dropdown-small flex-grow-1" container="body">
                    <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                      {{
                        category ? (filterCategories | getByField:"id":category:"code") : t(
                          "competitor.table.category")
                      }}
                    </div>
                    <div ngbDropdownMenu aria-labelledby="categoryDropdown">
                      <button ngbDropdownItem (click)="handleCategorySelection()">
                        {{t("app.common.all")}}
                        @if ((category === undefined)) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      @for (item of filterCategories;track item) {
                        <button ngbDropdownItem (click)="handleCategorySelection(item.id)">
                          {{item.code}}
                          @if (item.id == category) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                      }
                    </div>
                  </div>
                }

                @if (race?.raceSettings?.measurementType === MeasurementTypes.CHIP_TIME_PRIMARY) {
                  <div ngbDropdown class="dropdown-small" container="body">
                    <div class="dropdown" id="measurementTypeDropdown1" ngbDropdownToggle>
                      {{
                        measurementType === MeasurementTypes.CHIP_TIME_PRIMARY ? t("competitor.table.results.net.time")
                          : t("competitor.table.results.gross.time")
                      }}
                    </div>
                    <div ngbDropdownMenu aria-labelledby="measurementTypeDropdown1">
                      <button ngbDropdownItem
                              (click)="handleMeasurementTypeSelection(MeasurementTypes.CHIP_TIME_PRIMARY)">
                        {{t('competitor.table.results.net.time')}}
                        @if (MeasurementTypes.CHIP_TIME_PRIMARY == measurementType) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      <button ngbDropdownItem
                              (click)="handleMeasurementTypeSelection(MeasurementTypes.GUN_TIME_PRIMARY)">
                        {{t('competitor.table.results.gross.time')}}
                        @if (MeasurementTypes.GUN_TIME_PRIMARY == measurementType) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                    </div>
                  </div>
                } @else if (race?.raceSettings?.measurementType === MeasurementTypes.GUN_TIME_PRIMARY) {
                  <div ngbDropdown class="dropdown-small" container="body">
                    <div class="dropdown" id="measurementTypeDropdown2" ngbDropdownToggle>
                      {{
                        measurementType === MeasurementTypes.CHIP_TIME_PRIMARY ? t("competitor.table.results.net.time")
                          : t("competitor.table.results.gross.time")
                      }}
                    </div>
                    <div ngbDropdownMenu aria-labelledby="measurementTypeDropdown2">
                      <button ngbDropdownItem
                              (click)="handleMeasurementTypeSelection(MeasurementTypes.GUN_TIME_PRIMARY)">
                        {{t('competitor.table.results.gross.time')}}
                        @if (MeasurementTypes.GUN_TIME_PRIMARY == measurementType) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      <button ngbDropdownItem
                              (click)="handleMeasurementTypeSelection(MeasurementTypes.CHIP_TIME_PRIMARY)">
                        {{t('competitor.table.results.net.time')}}
                        @if (MeasurementTypes.CHIP_TIME_PRIMARY == measurementType) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    }
    <ng-content/>
    @if (results?.length ?? 0 > 0) {
      <div>
        @for (competitor of results;track competitor) {
          <!--              Mobile list item-->
          <div class="d-flex flex-column d-flex d-lg-none">
            <ng-container>
              <ng-container *ngTemplateOutlet="competitorMobileItem; context: {
              competitor: competitor,
              category: category,
              gender: gender,
              measurementType: measurementType,
              firstCompetitorResults: firstCompetitorResults,
              isAdmin: isAdmin,
              race: race,
              isTeam: (Array.isArray(competitor?.competitorResultsDetail?.team) &&
                        competitor!.competitorResultsDetail!.team!.length > 0),
              $last: $last
            }"></ng-container>
            </ng-container>
          </div>
        }
        <div class="d-none d-lg-flex position-relative">
          <div class="d-flex flex-column scroll-btn-box">
            <button class="scroll-btn" (click)="scrollTable(true)">
              <img src="assets/icons/icons-alt/arrow-right.svg" alt="Scroll table right">
            </button>
            <button class="scroll-btn" (click)="scrollTable(false)">
              <img src="assets/icons/icons-alt/arrow-left.svg" alt="Scroll table left">
            </button>
          </div>

          <div class="table-responsive table-responsive--addon">
            <table class="table align-middle">
              <thead class="sticky-table-header">
              <tr>
                <th scope="col" class="rank-column-width">{{t("competitor.table.absolute.rank")}}</th>
                <th scope="col" class="start-number-column-width">{{t('competitor.table.start.number')}}</th>
                <th scope="col" class="name-column-width">{{t('competitor.table.first.and.last.name')}}</th>
                <th scope="col" class="status-col-width">{{t('competitor.table.status')}}</th>
                <th scope="col" class="time-column-width">{{t('competitor.table.time')}}</th>
                <th scope="col" class="gap-column-width">{{t('competitor.table.gap')}}</th>
                <th scope="col" class="cp-column-width">{{
                    isRoundRace() ?
                      t('competitor.table.laps') : t('competitor.table.cp')
                  }}
                </th>
                @if (!isRoundRace()) {
                  <th scope="col" class="cp-location-col-width">{{
                      t('organiser.event.details.control.point.waypointType.3')
                    }}
                  </th>
                  @if (controlWaypoints?.length ?? 0 > 0) {
                    @for (cp of controlWaypoints;track cp) {
                      <th scope="col" class="cp-location-col-width">
                        <div class="cp-location-col-width__trim">
                          {{
                            controlWaypoints | waypointNameById:cp.id
                          }}
                        </div>
                      </th>
                    }
                  }
                  <th scope="col" class="cp-location-col-width">{{
                      t('organiser.event.details.control.point.waypointType.4')
                    }}
                  </th>
                }
              </tr>
              </thead>
              <tbody #tbody>
                @for (competitorResults of results;track competitorResults) {
                  <tr>
                    <td class="rank-column-width">{{competitorResults | rank:category:gender:measurementType}}</td>
                    <td class="start-number-column-width">
                      <div class="start-number-badge" (click)="openDetailsModal(competitorResults)">
                        {{competitorResults.startNumber}}
                        <span class="ps-1">
                          <img src="assets/icons/icons-alt/search-list-02.svg" alt="Open details"/>
                        </span>
                      </div>
                    </td>
                    <td class="name-column-width">
                      <div class="d-flex flex-row align-items-center">
                        @if (Array.isArray(competitorResults?.competitorResultsDetail?.team) &&
                        competitorResults!.competitorResultsDetail!.team!.length > 0) {
                          <div class="d-flex flex-column">
                            @for (member of competitorResults?.competitorResultsDetail?.team;track member) {
                              <span>
                              {{
                                  ((member?.fn ?? "") | titlecase) + " " + ((member?.ln ?? "") | titlecase)
                                }}
                            </span>
                            }
                          </div>
                        } @else {
                          {{
                            ((competitorResults?.firstName ?? "")| titlecase) + " " + ((competitorResults?.lastName
                              ?? "") | titlecase)
                          }}
                        }
                        @if (!(Array.isArray(competitorResults?.competitorResultsDetail?.team)
                          && competitorResults!.competitorResultsDetail!.team!.length > 0)) {
                          <div class="d-flex justify-content-center justify-content-start ps-2">
                            @if (competitorResults.sex === 1) {
                              <div class="badge-holder__badge gender-badge-man me-1">
                              <span class="text-uppercase">
                                {{t("app.common.gender.short.1")}}
                              </span>
                              </div>
                            } @else if (competitorResults.sex === 2) {
                              <div class="badge-holder__badge gender-badge-women me-1">
                              <span class="text-uppercase">
                                {{t("app.common.gender.short.2")}}
                              </span>
                              </div>
                            } @else {
                              <div class="badge-holder__badge gender-badge-man me-1">
                              <span class="text-uppercase">
                                {{"-"}}
                              </span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <div class="badge-holder__badge finished">
                          <span class="text-uppercase">
                            {{
                              competitorResults.status ? competitorResults.status : "-"
                            }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}</td>
                    <td>{{
                        competitorResults.competitorResultsDetail |
                          resultsGapTime:firstCompetitorResults?.competitorResultsDetail:measurementType:race?.raceSettings?.measurementPrecisionType
                      }}
                    </td>
                    <td
                      class="text-center">{{competitorResults.competitorResultsDetail | nmControlPointsOrLaps:isRoundRace()}}
                    </td>
                    @if (!isRoundRace()) {
                      <td>{{
                          competitorResults?.competitorResultsDetail?.st_tm|
                            resultDateTime:competitorResults?.competitorResultsDetail?.st_dc:race?.raceSettings?.measurementPrecisionType
                        }}
                      </td>
                      @if (controlWaypoints?.length ?? 0 > 0) {
                        @for (cp of controlWaypoints;track cp) {
                          <td>
                            @if (competitorResults?.competitorResultsDetail?.SGS &&
                            competitorResults?.competitorResultsDetail?.SGS![cp.id!]) {
                              <div>{{
                                  competitorResults?.competitorResultsDetail?.SGS![cp.id!].ps_tm|
                                    resultDateTime:competitorResults?.competitorResultsDetail?.SGS![cp.id!].ps_dc:race?.raceSettings?.measurementPrecisionType
                                }}
                              </div>
                              <div>{{competitorResults?.competitorResultsDetail?.SGS![cp.id!].nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}</div>
                              <div>{{
                                  '('
                                  + (competitorResults?.competitorResultsDetail?.SGS![cp.id!].tl_tm|resultTime:race?.raceSettings?.measurementPrecisionType)
                                  +
                                  ')'
                                }}
                              </div>
                              <div class="d-flex flex-row">
                                <div class="badge-holder__badge rank-badge">
                                  <span class="text-uppercase">
                                    {{competitorResults?.competitorResultsDetail?.SGS![cp.id!] | rank:category:gender:measurementType:true}}
                                  </span>
                                </div>
                              </div>
                            }
                          </td>
                        }
                      }
                      <td>
                        @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                          <div>{{
                              competitorResults?.competitorResultsDetail?.fn_tm|
                                resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType
                            }}
                          </div>
                          @if ((controlWaypoints?.length ?? 0) > 0 && competitorResults.status
                          === CompetitorStatus.FIN) {
                            <div>{{
                                '('
                                + (competitorResults?.competitorResultsDetail?.SGS|finishAndLastCpDiff:race?.raceSettings?.measurementPrecisionType)
                                + ')'
                              }}
                            </div>
                          }
                          <div>{{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}</div>
                          <div class="d-flex flex-row">
                            <div class="badge-holder__badge rank-badge">
                            <span class="text-uppercase">
                              {{competitorResults | rank:category:gender:measurementType}}
                            </span>
                            </div>
                          </div>
                        } @else {
                          {{"-"}}
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="sticky-shadow"></div>
        </div>
      </div>
    } @else if (!isLoading) {
      <div class="px-0 pt-2">
        <app-empty-state/>
      </div>
    }
    @if (hasMore) {
      @if (isAdmin) {
        <div class="pt-16">
          <app-admin-load-more (loadMore)="loadMore()"/>
        </div>
      } @else {
        <div class="d-flex justify-content-center load-more-wrapper py-5">
          <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [text]="t('app.common.load.more')"
                          [borderColor]="'var(--teal-500)'" (onClickCallback)="loadMore()"></app-button-alt>
        </div>
      }
    }
    @if (showFabButton && (results?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>

  <ng-template #competitorMobileItem let-competitor="competitor" let-category="category" let-gender="gender" let-isTeam="isTeam"
               let-measurementType="measurementType" let-firstCompetitorResults="firstCompetitorResults"
               let-isAdmin="isAdmin" let-race="race" let-$last="$last">
    <div class="d-flex flex-column fs-14 grey-neutral-600" [ngClass]="{ 'competitor-item-mobile': true }" [ngStyle]="{
         'border-bottom': $last ? 'none' : '1px solid var(--teal-200)',
         'padding-top': '16px',
         'padding-bottom': $last ? '0' : '16px'
       }" (click)="openDetailsModal(competitor, true)">
      <div class="d-flex flex-row align-items-center justify-content-between pb-2">
        <div class="d-flex flex-row align-items-center">
                  <span class="badge rounded-pill me-2 result-badge-mobile">
          {{competitor | rank:category:gender:measurementType:false:true}}
        </span>
          <span class="fw-medium">
                  @if (Array.isArray(competitor?.competitorResultsDetail?.team) &&
                        competitor!.competitorResultsDetail!.team!.length > 0) {
              {{(competitor?.lastName ?? "")| titlecase}}
              } @else {
              {{
              ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                ?? "") | titlecase)
                          }}
                        }
          </span>
        </div>
        <div class="d-inline-flex">
          <span class="pe-3">
              @if (isRound) {
                    <span>
                        {{t("measurements.controlpoints.lap")}}
                        {{competitor.competitorResultsDetail | nmControlPointsOrLaps:true}}
                    </span>
              }
              @else {
                {{
                    competitor.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType
                 }}
              }
          </span>
          <span class="cursor-pointer">
            <img src="assets/icons/icons-alt/chevron-circle.svg" alt="Open details"/>
          </span>
        </div>
      </div>

      <div class="d-flex flex-wrap align-items-center">
        <span class="fw-medium me-1">{{t("competitor.table.status.BIB")}}</span>
        <span>{{competitor.startNumber}}</span>
        @if (isTeam) {
          <div class="item-separator"></div>
           @for (member of competitor?.competitorResultsDetail?.team;track member;let lastMember = $last) {
                {{
                    ((member?.fn ?? "") | titlecase) + " " + ((member?.ln ?? "") | titlecase)
                }}
                @if (member.sx) {
                    <span>{{', '}}{{t("app.common.gender.short." + member.sx)}}</span>
                }
                @if (member.cty) {
                    <span>{{', '}}{{member.cty}}</span>
                }
                @if (!lastMember) {
                    <div class="item-separator"></div>
                }
            }
          }
          @else {
            <div class="item-separator"></div>
                <span>{{t("app.common.gender.short." + competitor.sex)}}</span>
          }

        @if (!isTeam && competitor.country) {
            <div class="item-separator"></div>
            <span>{{competitor.country}}</span>
        }
        @if (competitor.club) {
            <div class="item-separator"></div>
            <span>{{competitor.club}}</span>
        }
      </div>

      <div class="d-flex flex-wrap align-items-center">
<!--        LTP -->
          @if (isRound) {
          <span class="fw-medium me-1">{{t("competitor.table.time")}}</span>
             <span>
            {{ competitor.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}
             </span>
          }
          @else if (competitor?.competitorResultsDetail | ltpCompetitorStageDetail) {
          <span class="fw-medium me-1">LTP</span>
            <span>{{(competitor?.competitorResultsDetail | ltpCompetitorStageDetail)|waypointNameByWaypointId}}</span>
          }

          @if ((isRound || (competitor?.competitorResultsDetail | ltpCompetitorStageDetail)) && competitor.categoryLabel) {
            <div class="item-separator"></div>
          }

          @if (competitor.category) {
            <span class="fw-medium me-1">{{t("app.common.category.short")}}</span>
            <span class="text-uppercase">{{competitor.categoryLabel}}</span>
          }

      </div>
    </div>
  </ng-template>
</ng-container>

